import { render, staticRenderFns } from "./passwordForgot.vue?vue&type=template&id=3b3242c5&scoped=true&"
import script from "./passwordForgot.vue?vue&type=script&lang=js&"
export * from "./passwordForgot.vue?vue&type=script&lang=js&"
import style0 from "./passwordForgot.vue?vue&type=style&index=0&id=3b3242c5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3242c5",
  null
  
)

export default component.exports